import { Box } from '@/components/ui/box'
import { Text } from '@/components/ui/typography'
import { appEnvName } from '@/env/vars.ts'

const ImpersonationBanner = () => {
    const mudId = localStorage.getItem('spoofUser')

    const beYourself = () => {
        localStorage.removeItem('spoofUser')
        window.location.reload()
    }

    const impersonate = () => {
        const mudid = prompt('Enter MUD ID')
        if (mudid) {
            localStorage.setItem('spoofUser', mudid)
            window.location.reload()
        }
    }

    if (!mudId || appEnvName === 'prod') return
    return (
        <Box p="18px" fontSize="16px" bgColor="#ffb800" color="var(--chakra-colors-dark-700)" gap="5px" textAlign="center">
            <Text as="span">
                You are impersonating <b>{mudId}</b>.&nbsp;
            </Text>
            <Text as="span" textDecor="underline" cursor="pointer" onClick={beYourself}>
                Be yourself
            </Text>
            <Text as="span">&nbsp;or&nbsp;</Text>
            <Text as="span" textDecor="underline" cursor="pointer" onClick={impersonate}>
                impersonate someone else.
            </Text>
        </Box>
    )
}

export default ImpersonationBanner
